import participation from "./participation";
import tracking from "./tracking";
import admin from "./admin";
import demo from "./demo";

export default {participation, tracking, admin, demo}